<template>
  <component
    :is="tag"
    :style="`--button-bg: ${color}`"
    class="color-button"
    @click="$emit('click')"
    :to="to"
  >
    <slot />
  </component>
</template>

<script>
import subjectColors from '@/utils/subject-colors'

export default {
  name: 'ColorButton',

  props: {
    color: {
      type: String,
      default: subjectColors[subjectColors.length - 1].value
    },

    tag: {
      type: String,
      default: 'button'
    },

    to: {
      type: [String, Object],
      default: ''
    }
  }
}
</script>

<style lang="scss">
.color-button {
  padding: 0 1rem;
  width: 100%;
  line-height: 3rem;
  display: block;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: (1rem / 32);
  background: var(--button-bg);
  color: #263238;
  border: 0;
  border-radius: 1.5rem;
  text-decoration: none;
  text-align: center;

  &:hover,
  &:active {
    color: #263238;
    box-shadow: 0 0 0 .125rem var(--button-bg);
  }

  &:visited {
    color: #263238;
  }

  &:focus {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem var(--button-bg);
  }
}
</style>
